import { render, staticRenderFns } from "./idleFlipbookDetails.vue?vue&type=template&id=e6b1324e&scoped=true&"
import script from "./idleFlipbookDetails.vue?vue&type=script&lang=js&"
export * from "./idleFlipbookDetails.vue?vue&type=script&lang=js&"
import style0 from "./idleFlipbookDetails.vue?vue&type=style&index=0&id=e6b1324e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b1324e",
  null
  
)

export default component.exports